export const APP_STORE_APP_ID = '6757862504';

export const APP_STORE_URL =
  'https://apps.apple.com/tr/app/ar%C4%B1za-rehberim-oto-te%C5%9Fhis/id6757862504';

export const APP_STORE_SOCIAL_CAMPAIGN_URL =
  'https://apps.apple.com/app/apple-store/id6757862504?pt=128149896&ct=Social%20Media&mt=8';
